// src/services/taxApi.js
// API de Impuestos (TAX) según documentación:
// GET tax.php → lista | GET tax.php/{id} → detalle
// POST tax.php → crear | PUT tax.php/{id} → actualizar | DELETE tax.php/{id} → eliminar

import { dotoniwoofApi } from '../api/dotoniwooApi';

const TAX_BASE = '/tax.php';

const apiResult = (response) => ({
  ok: true,
  status: response.status,
  data: response.data
});

const apiError = (error) => ({
  ok: false,
  status: error.response?.status || 500,
  data: error.response?.data || { message: 'Error de conexión' }
});

/**
 * Lista todos los impuestos
 * @param {Object} params - { scope?: 'compra'|'venta'|'gasto', active?: '1' }
 * @returns {Promise<Object>}
 */
export const getTaxes = async (params = {}) => {
  try {
    const response = await dotoniwoofApi.get(TAX_BASE, { params });
    return apiResult(response);
  } catch (error) {
    console.error('Error al obtener impuestos:', error);
    return apiError(error);
  }
};

/**
 * Obtiene un impuesto por ID
 * @param {number|string} id - ID del impuesto
 * @returns {Promise<Object>}
 */
export const getTaxById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`${TAX_BASE}/${id}`);
    return apiResult(response);
  } catch (error) {
    console.error('Error al obtener impuesto:', error);
    return apiError(error);
  }
};

/**
 * Crea un impuesto
 * @param {Object} payload - { firebase_UID, description, scope, rate [, value, is_withholding, ...] }
 * @returns {Promise<Object>}
 */
export const createTax = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(TAX_BASE, payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al crear impuesto:', error);
    return apiError(error);
  }
};

/**
 * Actualiza un impuesto
 * @param {number|string} id - ID del impuesto
 * @param {Object} payload - Campos a actualizar
 * @returns {Promise<Object>}
 */
export const updateTax = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${TAX_BASE}/${id}`, payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al actualizar impuesto:', error);
    return apiError(error);
  }
};

/**
 * Elimina un impuesto
 * @param {number|string} id - ID del impuesto
 * @param {string} firebase_UID - UID de Firebase del usuario
 * @returns {Promise<Object>}
 */
export const deleteTax = async (id, firebase_UID) => {
  try {
    const response = await dotoniwoofApi.delete(`${TAX_BASE}/${id}`, {
      data: { firebase_UID },
      params: { firebase_UID }
    });
    return apiResult(response);
  } catch (error) {
    console.error('Error al eliminar impuesto:', error);
    return apiError(error);
  }
};
